import { useState, useEffect } from "react";
import { deleteApi, getApi, postApi, putApi } from "../../services/api";
import { useForm } from "antd/es/form/Form";
import { toast } from "react-toastify";
// import { courseCategoryData } from "../../services/AdminDashBoard/courseCategoryData";

export default function useCourseCategories() {
	const [searchTerm, setSearchTerm] = useState("");
	const [categories, setCategories] = useState([]); // Ensure you manage this state
	const [filteredCategories, setFilteredCategories] = useState([]); // Ensure this state is managed
	const [isModalVisible, setIsModalVisible] = useState(false);
	const [modalType, setModalType] = useState("");
	const [formType, setFormType] = useState("");
	const [selectedCategory, setSelectedCategory] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const [form] = useForm();

	// Fetch categories data from the database
	useEffect(() => {
		const fetchCategories = async () => {
			try {
				const response = await getApi(`/courseCategory`);

				if (response && !response.error) {
					setCategories(response); // Set fetched categories
					setFilteredCategories(response); // Update filtered categories
				} else {
					console.error(
						"Error fetching categories:",
						response.message || "Unknown error"
					);
				}
			} catch (error) {
				console.error("Error fetching categories:", error.message);
			}
		};

		fetchCategories();
	}, []);

	// Update filtered categories based on the search term
	useEffect(() => {
		if (searchTerm === "") {
			setFilteredCategories(categories);
		} else {
			setFilteredCategories(
				categories.filter((category) =>
					category.title
						.toLowerCase()
						.includes(searchTerm.toLowerCase())
				)
			);
		}
	}, [searchTerm, categories]);

	const showModal = (type, category) => {
		setModalType(type);
		setSelectedCategory(category);
		if (type === "edit") {
			// Ensure that availableTimes are set for viewing
			form.setFieldsValue({
				...category,
			});
		} else {
			form.resetFields();
		}
		setIsModalVisible(true);
		setIsModalVisible(true);
	};

	const handleModalConfirm = async (values) => {
		const formData = new FormData();
		Object.entries(values).forEach(([key, value]) => {
			if (key.startsWith("video")) {
				formData.append("video", value?.originFileObj);
				return;
			}
			if (key.startsWith("image")) {
				formData.append("image", value?.originFileObj);
				return;
			}

			formData.append(key, value);
		});
		try {
			if (modalType === "edit") {
				await putApi(
					`/courseCategory/${selectedCategory._id}`,
					formData
				);
				toast.success("Category edited successfully!");
			} else if (modalType === "delete") {
				await deleteApi(`/courseCategory/${selectedCategory._id}`);
				toast.success("Category deleted successfully!");
			} else if (modalType === "add") {
				await postApi(`/courseCategory`, formData);
				toast.success("Category added successfully!");
			}
			// if (!response.error) {
			// 	const updatedCategory = response;
			// 	if (modalType === "edit") {
			// 		setCategories((prev) =>
			// 			prev.map((category) =>
			// 				category.id === selectedCategory._id
			// 					? updatedCategory
			// 					: category
			// 			)
			// 		);
			// 		setFilteredCategories((prev) =>
			// 			prev.map((category) =>
			// 				category.id === selectedCategory._id
			// 					? updatedCategory
			// 					: category
			// 			)
			// 		);
			// 	} else if (modalType === "add") {
			// 		setCategories((prev) => [...prev, updatedCategory]);
			// 		setFilteredCategories((prev) => [...prev, updatedCategory]);
			// 	}
			// } else {
			// 	console.error("Error updating category:", response.message);
			// }
		} catch (error) {
			toast.error("Error updating category:", error.message);
		}

		setIsModalVisible(false);
	};

	const handleModalCancel = () => {
		setIsModalVisible(false);
	};

	return {
		searchTerm,
		setSearchTerm,
		categories,
		setCategories,
		filteredCategories,
		setFilteredCategories,
		isModalVisible,
		setIsModalVisible,
		modalType,
		setModalType,
		formType,
		setFormType,
		selectedCategory,
		setSelectedCategory,
		form,
		showModal,
		handleModalConfirm,
		handleModalCancel,
		selectedFile,
		setSelectedFile,
	};
}
